(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["black-friday-btn"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("bf-guarantee-btn");
  const modal = document.getElementById("bf-guarantee-modal");
  const closeBtn = document.querySelector(".bf-close");
  const closerBtn = document.querySelector(".bf-closer");
  if(btn){
btn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    modal.style.display = "block";
    document.body.classList.add("bf-modal-open");
  });
  }
  

  closeBtn.addEventListener("click", function () {
    modal.style.display = "none";
    document.body.classList.remove("bf-modal-open");
  });
    closerBtn.addEventListener("click", function () {
        modal.style.display = "none";
        document.body.classList.remove("bf-modal-open");
    });
  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
      document.body.classList.remove("bf-modal-open");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const modalContent = document.querySelector(".bf-modal-content");
  const header = document.querySelector("#shopify-section-header"); // adjust selector
  if(header && modalContent){
    const headerHeight = header.offsetHeight;
    modalContent.style.marginTop = (headerHeight + 10) + "px"; // 10px below header
  }
});
  } catch(e) { console.error(e); }
})();

})();
